import { module } from "modujs";
import { html } from "../utils/environment";
import { FocusTrap } from 'focus-trap-vue'

Vue.component('FocusTrap', FocusTrap)

const PREVIEW_WIDTH = 85 * 2
const PREVIEW_HEIGHT = 85 * 2

export default class extends module {
    constructor(m) {
        super(m);

        this.closeBind = (e) => {
            if (e.key === "Escape") {
                // const isAccordionItemOpen = document.querySelector('[data-accordions="content"].is-active') 
                // if (!isAccordionItemOpen) {
                this.close();
                // }
            }
        }
    }

    init() {
        // Events
        this.bindEvents()

        // Init vue
        this.initVue();
    }

    destroy() {
        this.unbindEvents()
    }

    bindEvents() {
        document.addEventListener('keyup', this.closeBind)
    }

    unbindEvents() {
        document.removeEventListener('keyup', this.closeBind)
    }

    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this;

        /////////////////////////
        // Settings
        Vue.config.devtools = true;

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
            el: this.el,

            delimiters: ["${", "}"],

            data: {
                searchInput: '',
                products: [],
                articles: [],
                isActive: false
            },

            watch: {
                'searchInput': function (searchValue) {
                    this.requestSuggestDebounce(searchValue)
                },

                'products': function (productsArr, oldProductsArr) {
                    this.$nextTick(() => {
                        const isEmpty = productsArr.length ? false : true

                        if (oldProductsArr.length > productsArr.length && !isEmpty) {
                            setTimeout(() => {
                                this.setSuggestHeight(isEmpty)
                            }, 400)
                        } else {
                            this.setSuggestHeight(isEmpty)
                        }
                    })
                },

                'articles': function (articlesArr, oldArticlesArr) {
                    this.$nextTick(() => {
                        const isEmpty = articlesArr.length ? false : true

                        if (oldArticlesArr.length > articlesArr.length && !isEmpty) {
                            setTimeout(() => {
                                this.setSuggestHeight(isEmpty)
                            }, 400)
                        } else {
                            this.setSuggestHeight(isEmpty)
                        }
                    })
                }
            },

            beforeCreate() {
                this.moduleInstance = moduleInstance
            },

            created() {
                this.isRequested = false
                this.requestPool = []

                this.suggestOptions = {
                    type: "product,article",
                    limit: 8,
                    options: {
                        unavailable_products: "last"
                    }
                }
            },

            mounted() {
                this.requestSuggestDebounce = this.debounceCall(this.requestSuggest, 500)

            },

            beforeDestroy() {

            },

            methods: {
                async requestSuggest(searchValue) {
                    // console.log("request ----", searchValue)

                    // Check if last request and if last fetch is ended
                    if (!this.requestPool.length && !this.isRequested) {

                        // Fetch state
                        this.isRequested = true

                        if (searchValue) {
                            // Get suggests
                            await this.fetchSuggest(searchValue)
                        } else {
                            this.products = []
                            this.articles = []
                        }

                        // Fetch state
                        this.isRequested = false

                        // If there are request during the last fetch
                        if (this.requestPool.length) {
                            // Get last request
                            const nextSearchValue = this.requestPool[this.requestPool.length - 1]
                            // Clear pool
                            this.requestPool = []
                            // Then fetch again
                            this.requestSuggest(nextSearchValue)
                        }

                        // Else store request while fetch is executing
                    } else {
                        this.requestPool.push(searchValue)
                    }
                },

                fetchSuggest(searchValue) {
                    // console.log("----- search", searchValue)

                    return new Promise((resolve) => {
                        // https://shopify.dev/docs/themes/ajax-api/reference/predictive-search
                        fetch(`/search/suggest.json?q=${searchValue}&resources[type]=${this.suggestOptions.type}&resources[limit]=${this.suggestOptions.limit}&resources[options][unavailable_products]=${this.suggestOptions.options.unavailable_products}`)
                            .then(response => response.json())
                            .then(suggestions => {

                                // Retrieve products
                                const productSuggestions = suggestions.resources.results.products;

                                if (productSuggestions.length > 0) {
                                    const products = suggestions.resources.results.products;

                                    // Update featured_image
                                    products.forEach((product) => {
                                        product.featured_image.url = this.getResizedImageUrl(product.featured_image.url)
                                        product.featured_image.width = PREVIEW_WIDTH
                                        product.featured_image.height = PREVIEW_HEIGHT
                                    })
                                    // Populate product array
                                    this.products = products
                                } else {
                                    // Clear product array
                                    this.products = []
                                }

                                // Retrieve article
                                const articleSuggestions = suggestions.resources.results.articles;

                                if (articleSuggestions.length > 0) {
                                    const articles = suggestions.resources.results.articles;

                                    const filteredArticles = articles.filter((value, index, self) =>
                                        index === self.findIndex((t) => (
                                            t.handle === value.handle
                                        ))
                                    )

                                    // Update featured_image
                                    filteredArticles.forEach((article) => {
                                        article.featured_image.url = this.getResizedImageUrl(article.featured_image.url)
                                        article.featured_image.width = PREVIEW_WIDTH
                                        article.featured_image.height = PREVIEW_HEIGHT
                                    })
                                    
                                    // Populate article array
                                    this.articles = filteredArticles
                                } else {
                                    // Clear article array
                                    this.articles = []
                                }

                                resolve()
                            });

                    })

                },

                getResizedImageUrl(imageUrl) {
                    const splitUrl = imageUrl.split('.')
                    const sizeExtension = `_${PREVIEW_WIDTH}x${PREVIEW_HEIGHT}_crop_center.${splitUrl.pop()}`
                    return splitUrl.join('.') + sizeExtension
                },

                setSuggestHeight(isHidden) {
                    if (isHidden) return this.$el.style.setProperty('--suggestHeight', `0px`);
                    const suggestHeight = this.$refs.suggest.offsetHeight
                    this.$el.style.setProperty('--suggestHeight', `${suggestHeight}px`);
                },

                onResize() {
                    const isEmpty = this.products.length ? false : true
                    this.setSuggestHeight(isEmpty)
                },

                onToggle() {
                    this.moduleInstance?.toggle()
                },

                onOpen() {
                    this.isActive = true

                    setTimeout(() => {
                        this.$refs.input.focus()
                    }, 700)
                },

                onClose() {
                    this.searchInput = ""
                    this.products = []
                    this.isActive = false
                },

                displayDate(publishedAt) {
                    const date = new Date(publishedAt)
                    return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' })
                },

                debounceCall(func, delay) {
                    let debounceTimer;
                    return function () {
                        const context = this;
                        const args = arguments;
                        clearTimeout(debounceTimer);
                        debounceTimer = setTimeout(() => func.apply(context, args), delay);
                    };
                }
            }
        });
    }

    toggle() {
        if (html.classList.contains('has-search-open')) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        html.classList.add('has-search-open')
        this.call('close', null, 'Menu')
        this.call('onCloseModal', null, 'CartModal')
        this.app?.onOpen?.()
    }

    close() {
        html.classList.remove('has-search-open')
        this.app?.onClose?.()
    }

    destroy() {
        super.destroy();

        if (this.app) {
            this.app.$destroy();
        }
    }
}
